"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenubar = void 0;
const react_1 = require("react");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const navigation_context_1 = require("../navigation/navigation-context");
const force_render_1 = require("../../utils/force-render");
function useMenubar(options) {
    const { navigate } = react_1.useContext(navigation_context_1.NavigationContext);
    const { forceRender } = force_render_1.useForceRender();
    const itemsRef = react_1.useRef(options.items);
    const handleLogoClick = event_callback_hook_1.useEventCallback(() => {
        navigate(options.logoUrl);
    });
    const modifyItems = event_callback_hook_1.useEventCallback((callback) => {
        const newItems = callback(itemsRef.current);
        itemsRef.current = newItems;
        forceRender();
    });
    const context = react_1.useMemo(() => ({
        modifyItems,
    }), [modifyItems]);
    return {
        handleLogoClick,
        context,
        items: itemsRef.current,
    };
}
exports.useMenubar = useMenubar;
//# sourceMappingURL=menubar-hook.js.map